import { h } from '@stencil/core'
import { JSXBase } from '@stencil/core/internal'
import { IconName } from 'src/icons'

import { ExternalLink } from '../utils/url'

export function getUniversalShareDisplayValueAndIcon(
  access,
  companyDomain?: string
): {
  displayValue: JSXBase.IntrinsicElements | string
  iconName?: IconName
} {
  switch (access) {
    case 'unselected': {
      return {
        displayValue: <span>No team-wide setting selected</span>,
      }
    }
    case 'universal': {
      return { iconName: 'globe', displayValue: <span>Anyone with the link can view</span> }
    }
    case 'universal_domain_restricted': {
      return {
        iconName: 'building-fill-lock',
        displayValue: companyDomain ? (
          <span class='flex gap-x-1'>
            Anyone <span class='flex-1 truncate'>@{companyDomain}</span> can view
          </span>
        ) : (
          <span>Anyone at your company can view</span>
        ),
      }
    }
    case 'universal_audience_restricted': {
      return {
        iconName: 'lock',
        displayValue: <span>Only people added can view</span>,
      }
    }
  }
}

export const GetFathomBadge = () => (
  <ExternalLink class='group text-info-warn' href='https://fathom.video/'>
    <aside class='flex items-center'>
      <svg viewBox='0 0 15.9 25' class='h-5 opacity-10 group-hover:opacity-100 transition duration-200 fill-current'>
        <path d='M0,12.5l14.35,12h0A2.48,2.48,0,0,0,15.9,25V0a2.48,2.48,0,0,0-1.52.53h0Z' />
      </svg>
      <span class='flex items-center pr-7px h-5 text-base font-bold group-hover:text-surface-base bg-info-warn bg-opacity-10 group-hover:bg-opacity-100 rounded-r transition duration-200'>
        <span class='block md:hidden'>Sign up for free</span>
        <span class='hidden md:block'>Get your own free AI Notetaker 🔥</span>
      </span>
    </aside>
  </ExternalLink>
)
